/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import type { NotificationPlacement } from 'antd/es/notification/interface';

export type SnackbarType = 'info' | 'success' | 'error' | 'warning' | 'open';

export interface SnackbarOptions {
    key?: React.Key;
    title?: React.ReactNode;
    message?: React.ReactNode;
    description?: React.ReactNode;
    duration?: number | null;
    btn?: React.ReactNode;
    type?: SnackbarType;
    icon?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
    onClose?: () => void;
    [k: string]: any;
}

export interface SnackbarContextValue {
    showSnackbar: (
        opts: SnackbarOptions | string,
        type?: Exclude<SnackbarType, 'open'>,
    ) => React.Key;
    closeSnackbar: (key: React.Key) => void;
    destroySnackbars: () => void;
    config: (
        conf: Partial<{
            duration: number | null;
            placement: NotificationPlacement;
            maxCount: number;
            top: number;
            bottom: number;
            getContainer?: () => HTMLElement | ShadowRoot;
        }>,
    ) => void;
}

export const SnackbarContext = React.createContext<SnackbarContextValue | null>(null);

export const useSnackbar = (): SnackbarContextValue => {
    const ctx = React.useContext(SnackbarContext);
    if (!ctx) throw new Error('useSnackbar must be used within SnackbarProvider');
    return ctx;
};

export default useSnackbar;
